export enum CustomerStatutoryDiscountType {
    NONE = 'NONE',
    SC = 'SC',    // Senior Citizen
    PWD = 'PWD',  // Person with Disability
    SP = 'SP',    // Solo Parent
    MOV = 'MOV',  // Medal of Valor Awardee
    NAAC = 'NAAC' // National Athlete / Coach
}